import * as React from 'react';

import { IOrgAddress } from '../../types/addressBook';
import { ICommonAddress } from '../../types/shipping';
import { isObjectEmpty } from '../../utils/helpers';
import { CompactOrgAddressView } from '../index';

import styles from './SingleAddress.module.scss';

interface IProps {
  address?: IOrgAddress | ICommonAddress;
}

export const SingleAddress: React.FC<IProps> = ({ address }) => {
  if (!address || isObjectEmpty(address)) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <CompactOrgAddressView
        row={address}
        addressClassName={styles.address}
        className={styles.addressContainer}
        isMultiline
      />
    </div>
  );
};

export default SingleAddress;
